/** cSpell:ignore captcha */
/**
 * API 配置
 * 数据接口走 restful 风格
 * 包含:
 * - get: GET
 * - post: POST
 * - put: PUT
 * - delete: DELETE
 * - upload: POST MULTIPART
 * - form: POST FORM
 * - head: HEAD
 */

/**
 * ! FOCUS
 * 本次为第一次提交，其中写下的接口为 YAPI 搬运而来，有些字段命难以捉摸
 * 比如下面，有些字段命为 A | B 之类的，是 YAPI 接口描述不清楚的暂时替代
 * 这里只是先列一个大概的清单，具体单词称谓需实际开发对接的时候做调整
 *
 * 而如果有些逻辑前端先行，可先用一个假api替代，以满足网络请求工具类的校验条件
 * eg: /api/foolish/bird/fly/first
 */

export default {
  // 核心接口
  core: {
    principal: '/api/ssoUser.do', // get 获取用户上下文信息
    permission: '/cust/pageCustInfo.do', //get 用户权限
    basic: '/cust/pageBaseSet.do', //获取时间间隔等基本信息
    overDue: '/cust/pageOverDue.do', // 用户是否逾期
    login: '/login.do', // form 登录请求
    logout: '/api/logout.do', // get 登出接口
    register: '/cust/saveRegistered.do', // post 注册请求
    checkRegister: '/cust/checkByRegistered.do', //校验公司名称是否被注册
    cartCount: '/cust/loadCartTotalAll.do', //获取购物车角标数量
    // menus: 'api/menu.do', // get 获取菜单数据
    menus: 'api/menu.do?showArea=1', // get 获取菜单数据
    sign: '/api/biz/cm/signingFlagByAn8.do', //get 是否需要签约弹框
    signDetail: '/api/biz/cm/querySigningArticle.do', //签约明细
    saveSign: '/api/biz/cm/saveSigning.do', //确认签约
    suvery: '/cust/judgeAdverPic.do', //查询是否需要展示问卷弹框
    surveyDetail: '/cust/pageAdverPic.do', // 查询问卷调查
    saveSuvery: ' /cust/saveAdverPic.do', //登记是否已经弹过问卷弹框
    randomCode: '/cust/getRandomTidWechat.do', //获取随机字符串
    smsVirifyCode: '/cust/genSmsVirifyCode.do', // get 获取手机号验证码
    smsVirifyCodeByLoginName: '/cust/genSmsVirifyCodeByLoginName.do', // get 根据账号获取手机号验证码
    checkSms: '/cust/checkSmsVirifyCode.do', //校验验证码  不用校验了
    submitInfo:'/cust/submitInformationWechat.do', // 获取验证码信息
    review: '/cust/submitInformationWechat.do', //再次校验身份信息
    submit: '/cust/savePwd3.do', //忘记密码提交
    reCheck: '/cust/reCheckInfoWechat.do', //再次校验用户是否重复提交
    changePwd: '/cust/savePwd4.do', //修改密码提交
    deleteBound: '/acl/userwechat/delu.do', //删除绑定关系,
    saveRemind: '/cust/saveArrivalRemind.do', //有货申请提交
    remindNumber: '/cust/querySetRemin.do', //查询设置提醒人数
    fillSuveryFlag: '/survey/queryDrawSurvey.do', //查询抽奖联动问卷状态
    submitFillSuvery: '/survey/patchInsertAnswer.do', //提交抽奖联动问卷
    getRewards: '/survey/reward.do',
    checkRewards: '/survey/queryLastReward.do', // 点击轮播时判断是否有奖励
    queryPointsInfo: '/points/sign/signRecord.do', // 获取签到弹窗积分信息
    signInConfirm: '/points/sign/sign.do',
    checkTodaySign: '/points/sign/checkTodaySign.do', // 校验用户是否签到
    getSsoToken: '/report/sso/getSsoToken.do',
  },
  // 通用接口
  common: {
    udc: '/api/com/udc.do', // get 获取udc
    address: '/base/getAreaList.do', // form 获取地址信息列表
    pack: '/cust/checkUnPack.do', // 加车判断商品是否可以拆包
    addToCart: '/cust/saveSoCart.do', //加入购物车
    batchAdd: '/cust/saveBatchCartAll.do', //批量加入购物车,
    batchAddByStock: '/cust/saveBatchCartAllByCode.do', // 按照标识加车
    shortageAddToCart: '/cust/saveShortageCart.do', //缺货加入购物车
    delivery: '/cust/initLogistic.do', //获取配送方式
    provinces: '/base/getAreaList.do', //省市区联动
    recognizeAddress: '/api/kuaidi100/addressResolution.do',
  },
  // 购物车enter
  cart: {
    uid: '/cust/getSoMasUid.do', //查询uidKey（防止用户重复提交订单）
    pockets: '/cust/loadPocketMoney.do', // get 获取可用红包
    coupons: '/cust/queryCoupons.do', // get 获取优惠券
    getBestDisComb: '/cust/getBestDisComb.do', // post 获取红包优惠券最大优惠组合
    shortagePockets: '/cust/loadShortagePocketMoney.do',
    shortageCoupons: '/cust/queryShortageCoupons.do', //缺货下单优惠券
    exportBI: '/cust/expQuotation.do', // get 导出报价单
    deleteBatch: '/cust/deleteMulCart.do', // delete 批量删除
    delete: '/cust/deleteSoCart.do', // delete 删除
    packAmt: '/cust/queryPackAmt.do', // post 获取拆包费用
    shortagePackAmt: '/cust/queryShortagePackAmt.do', //缺货的拆散费用
    packBatch: '/cust/cartBatchBreak.do', //批量拆散
    shortagePackBatch: '/cust/shortageCartBatchBreak.do', //缺货批量拆散
    breakUpBatch: '/cust/cartBatchSplitStock.do', // 批量拆分备货
    batchAddServices: '/cust/queryAllReprocess.do', // 批量增值服务
    confirmAddServices: '/cust/batchModifyReprocessing.do', // 批量增值服务确定按钮；逻辑
    warehouseList: '/cust/mcuByLoginNameAll.do', //获取仓库列表
    stockListByWarehouse: '/cust/queryMcuStock.do', // 获取某个仓库下的拆分标识
    itemList: '/cust/queryShoppingCart.do', // get 根据仓库信息获取商品列表
    batchTransferMcu: '/cust/batchTransfer.do', // 批量转移确定
    settleList: '/cust/checkoutSoCart.do', //结算页面明细
    settleSubmit: '/cust/placeAllOrder.do', //商品结算下单
    shortageList: '/cust/queryShortageCart.do', //缺货商品列表
    deleteBatchStortage: '/cust/deleteMulShortageCart.do', //批量删除缺货商品
    deleteStortage: '/cust/deleteShortageCart.do', //删除缺货商品
    packCheck: '/cust/checkDoPacked.do', // get 拆包校验
    shortagePackCheck: '/cust/checkShortageDoPacked.do', //缺货购物车的校验
    modify: '/cust/updateSoCartQty.do', //修改行数据
    modifyShortage: '/cust/updateShortageCartQty.do', //缺货商品数量修改
    // update: '/cust/handleUpdatePcs.do', //更新行数据
    update: '/cust/calProcessPrice.do', //更新行数据（优化）
    updateShortage: '/cust/calShortageProcessPrice.do', //更新缺货数据
    deletePack: '/cust/deleteSurcharge.do', //删除拆包服务费
    deleteShortagePack: '/cust/deleteShortageSurcharge.do', //删除缺货的增值服务和拆包费用
    getExtra: '/cust/queryCartReprocess.do', // get 获取增值服务
    getShortageExtra: '/cust/queryShortageCartReprocess.do', //缺货下单增值服务
    extra: '/cust/modifyReprocessing.do', // post 更新增值服务
    modifyExtra: '/cust/checkReprocessing.do', // post 校验选择的增值服务有没有达到上限
    shortageExtra: '/cust/modifyShortageReprocessing.do', //更新缺货增值服务
    submit: '/cust/placeOrder.do', //提交订单
    shortageSubmit: '/cust/placeShortageOrder.do', //提交缺货订单
    info: '/cust/thankOfAllOrderInfo.do', //感谢画面明细
    // shortageInfo: '/cust/thankOfShtOrderInfo.do', //缺货订单信息查询
    exportInfo: '/cust/expSoDetailPrompt.do', //感谢画面明细导出
    payInfo: '/cust/icbcCreateQrcodeUrl.do', // 获取支付url和code
    codeInfo: '/cust/queryIcbcQrcodeCollection.do', //查询二维码和订单信息,
    paymentStatus: 'cust/queryIcbcPaymentStatus.do', //查询支付状态
    logisticStatus: 'api/biz/cm/whinfos.do', //查询物流自提状态
    checkReprocessing: '/cust/checkReprocessingByOrder.do', // 混装混备，板箱台数计算费用接口
    querySplitStock: '/cust/querySplitStock.do', //  拆分备货
    querySsCode: '/cust/querySsCode.do', // 拆分备货新增生成编码
    editSsCode: '/cust/saveSplitStock.do', // 拆分备货新增编辑
    deleteSsCode: '/cust/deleteSplitStock.do', // 删除拆分备货
    getServiceAmt: '/api/b2b/handle/calculate.do', // 根据选择的地址获取代发服务费
    settleAccountAddress: '/cust/queryMemberAddress.do',
    exchangeInCart: '/points/strategy/exchangeInCart.do', // 结算页获取积分信息
    orderParsed: '/order/calculateSaveMoney.do',
    checkShoppingCart:'/cust/checkShoppingCart.do', // 校验要结算的商品是否下架
  },
  // 消息中心
  notification: {
    unread: '/cust/updateMsgStatusToUnRead.do', // 修改消息为未读
    read: '/cust/updateMsgStatusToRead.do', // 修改消息为已读
    delete: '/cust/deleteCustMidMsg.do', //删除消息
    type: '/cust/articlesB2B.do', // get 左侧公告类型
    list: '/cust/queryNoticeHelp.do', //获取消息列表
    detail: '/api/biz/cms/selestByAdId.do', //帮助中心和公告详情
    message: '/cust/queryMsgNotice.do', //通知列表
    messageDetail: '/cust/msgNoticeById.do',
  },
  // 首页
  home: {
    timeLimit: '/api/biz/sp/queryHomePageFlashSales.do', // get 限时促销查询接口
    coupon: 'cust/memberAcquireCoupon.do', //优惠券弹框接口
    promotion: '/cust/pagePromoteSale.do', // 查询是否需要促销
    shortcut: '/cust/pageKeywordLink.do', // 搜索框下部快捷选择
    carousel: '/cust/pagePic.do', // 顶部轮播
    catalogue: '/cust/pageCatalogue.do', // 菜单栏
    consult: '/cust/pageOnliConsul.do', // 在线咨询
    feedback: '/cust/saveFeedback.do', // 意见反馈
    exclusiveCustSer: '/cust/pageExclusiveCustSer.do', //专属客服
    feedbackRecord: '/cust/queryFeeBacks.do', //投诉记录查询
    feedbackCheck: 'cust/feedbackReturnOrder.do', // 投诉记录查询拖货
    feedbackRecordDetail: '/cust/queryFeedbackByFid.do', //投诉记录详情查询
    // feedbackRate: '/cust/updateComplainStatus.do', //意见反馈评价
    feedbackRate: '/cust/feedback/evaluate.do', //意见反馈评价
    feedbackUpgrade: '/cust/feedback/upgrade.do', // 投诉记录升级处理
    feedbackUpgradeCancel: '/cust/feedback/upgradeCancel.do', // 投诉记录撤回升级
    questionTypes: 'api/biz/cms/type.do',
    detectionTypes: '/api/biz/cms/detailType.do', // 获取检测项目
    saveCustMenu: 'api/biz/wm/saveCustMenu.do', // 自定义菜单保存，
    withdraw: '/cust/feedback/cancel.do', // 投诉记录撤回,
    getDetectionDetail: '/cust/getOneFeedback.do', //  根据检测服务id查询详情,
    updateFeedback: '/cust/updateFeedback.do', // 修改检测服务
    saveFeedback: '/cust/saveTestFeedback.do', // 保存检测服务,
    newSaveFeedback: '/cust/saveTestFeedbackNew.do', // 保存检测服务--新,
    withdrawFeedback: '/cust/cancelTestService.do', // 撤回检测服务
    getCouponNums: '/cust/testCoupon.do', // 获取检测服务有几张券
    getCoupons: '/cust/testCouponSelect.do', // 获取检测服务优惠券
    checkFileExist: '/api/sys/file/checkFileExists.do', // 检测服务列表校验文件是否存在
  },
  applyAfter: {
    questionTypes: 'api/biz/cms/getComplainTypeCodes.do', // 售后服务页面获取投诉类型
  },
  search: {
    catalogue: '/cust/catalogueSearch.do', // 查询搜索条件
    table: '/cust/queryCommodity.do', // 查询商品表的数据
    largeClass: '/cust/largeClassList.do', //获取大类
    subClass: '/cust/catList.do', // 获取小类
    catType: '/cust/catType.do', // 获取标准
    catalogueV2: '/cust/categoryCondition.do', // 查询搜索条件 v2
    catalogueV3: '/cust/es/dimension.do', // 查询搜索条件 v3
    tableV2: '/cust/search.do', // 查询商品表的数据 v2
    tableV3: '/cust/es/search.do', // 查询商品表的数据 v3
    typeImg: '/cust/categorysPic.do', // 商品图片
    commodityPic: '/cust/queryCommodityPic.do', // 列表图片明细
    commodityDraw: '/api/biz/wm/previewDrawing.do', // 列表带水印图纸
    gotoSquare: '/cust/es/searchOthers.do',
  },
  wireRod: {
    catalogue: '/cust/wireRodCondition.do', //查询搜索条件
    list: '/cust/queryWireRod.do', // 查询列表
  },
  orderCenter: {
    detail: {
      warehouse: '/cust/orderCustWh.do', //订单明细仓库
      list: '/cust/orderDetails.do', //订单明细列表
      export: '/cust/expSoDetail.do', //导出
      modify: '/cust/orderModifyQuery.do', //修改订单信息
      addCart: '/cust/saveToCartBySoId.do', //加车和再次下单
      //cancel: '/cust/cancelOrderDetail.do', //取消订单信息
      cancel: '/cust/cancelSoDetail.do',
      pay: '/cust/confirmPaymentStatus.do', //去支付
      hallmark: '/cust/judgeInvalidLotns.do', //查询品质证明是否展示
      logistics: '/cust/orderCenterLgsDesc.do', // 获取物流信息
      extraService: '/cust/queryAddProcess.do', //增值服务
      days: '/cust/queryRemarkAndDay.do', //预期有货天数和备注查询
      saleInfo: '/cust/queryActivityInfo.do', // 查询限时促销相关信息
      scActivity: '/cust/querySoMasInfo.do', //查询每个订单的类型和活动类型
      queryTrack: '/api/kuaidi100/queryTrack.do', // 查询物流100信息
    },
    orderTotal: {
      list: '/cust/deliveryOrderSum.do', //获取出货单列表
      export: '/cust/expSoSum.do', //导出
      b2bsoId: '/cust/queryAboutSoId.do', //b2bsoId查询
    },
    orderPrint: {
      list: '/cust/deliveryOrderPrint.do', //出货单列印
      main: '/cust/querySoPrint.do', //出货单列印（jsp）
      export: '/cust/expWord.do', //导出为word
    },
    payment: {
      list: '/cust/consolidatedPayment.do',
      export: '/cust/consolidatedPaymentExport.do',
    },
    accountDue: {
      list: '/cust/queryCustSoUnpaidSums.do',
      queryExpiredAmount: '/cust/calculUnpaid.do',
    },
    autoBill: {
      list: '/cust/automaticBilling.do', //自动对账单列表
      export: '/cust/expSoDetailsBill.do', //导出
    },
    pointOrder: {
      list: '/points/order/detail/pointsOrder.do',
      orderReceipt: '/points/order/receipt.do',
    },
    accountInvoice: {
      list: '/cust/invoiceList.do',
    },
    wireRecord:{
      list:'/cust/queryXcOrder.do',
      export:'/cust/expXcOrder.do'
    }
  },
  // 特价区
  sales: {
    carousel: '/api/biz/sp/specialitemsB2B.do', // get 商城特价区顶部轮播
    condition: '/api/b2b/mm/getItemSpcCondition.do', // get 特价区标准、直径、长度、材质、仓别等下拉数据（初始化）
    // list: '/api/b2b/mm/queryItemSpecial.do', // get 查询特价区商品表
    list: '/cust/es/queryItemSpecial.do', // get 查询特价区商品表
    favorite: '/cust/loadSelectCode.do', // 收藏夹下拉
    collect: '/cust/saveFavoriteSpec.do', // 收藏商品
    customCode: '/cust/custUserItem3.do', // 自定义编码查询
    saveCustom: '/cust/saveSpecCode.do', //保存自定义编码
  },
  discount: {
    carousel: 'api/b2b/sp/instantRebatesB2B.do', //轮播图
    condition: 'api/b2b/sp/getInstantRebateCondition.do', // 满减活动仓库、标准、直径、长度、材质等条件
    list: 'api/b2b/sp/queryInstantRebateItem.do', // 满减活动列表
  },
  moneyOffMulti: {
    //多满减活动
    carousel: 'api/b2b/sp/queryMultiInstant.do', //轮播图
    condition: 'api/b2b/sp/queryMultiCondition.do', // 满减活动仓库、标准、直径、长度、材质等条件
    list: 'api/b2b/sp/queryMultiItem.do', // 满减活动列表
  },
  flashSales: {
    timeCarousel: '/api/biz/sp/selectFlashSalesRounds.do', //限时秒杀拉取场次
    warehouse: '/api/biz/sp/selectCustWhInB2B.do', //限时秒杀获取仓库
    selectItems: '/api/biz/sp/selectItemsInB2B.do', //限时秒杀获取商品数据
    roundControl: '/api/biz/sp/queryControlByRoundId.do', //限时秒杀获取场次控制
    saleSettle: '/cust/checkoutFlashSales.do', //限时秒杀结算页面
    saleSubmit: '/cust/placeOrderInFlashSales.do', //限时秒杀提交订单
    introduce: 'api/biz/sp/queryIntroduction.do', //限时秒杀拉取活动规则
    currentTime: 'api/biz/sp/getCurrentTime.do', //限时秒杀获取当前时间
  },
  // 行业专区
  industries: {
    detail: '/api/biz/sp/queryIndustryInDetail.do', // get 行业营销商品查询接口
    industry: '/api/biz/sp/queryindustries.do', // get 商场行业专区查询接口
    // selection: '/cust/commodityCondOfPublic.do', //行业专区及特价区下拉框
    selection: '/api/biz/sp/queryIndustryCondition.do', //行业专区及特价区下拉框
    list: '/api/biz/sp/queryIndustryItem.do', // 行业专区商品列表数据查询
  },
  // favorite
  favorite: {
    favorites: '/cust/intoCollectionNew.do', //get 收藏夹
    list: '/cust/queryCollectionNew.do', // get 收藏夹对应表格信息
    delete: '/cust/deleteUserItems.do', //删除数据
    copy: '/cust/copyCollection.do', //复制收藏夹数据
    deleteSingle: '/cust/deleteUserItemColl.do', //单条删除
    deleteFav: '/cust/delFavorite.do', //清空收藏夹
    changeName: '/cust/renameFavorite.do', // 变更收藏夹名称
    priceList: '/cust/expCollection.do', //生成报价单
    quotationPreview: '/cust/quotation/previewFavorite.do', // 报价单预览
    batchAddCart: '/cust/quotation/saveBatchFavorite.do', // 报价单批量加入购物车
  },
  // 自定义编码
  customCode: {
    list: '/cust/getItemByCodePlaceOr.do', // 获取自定义编码列表（下单模块）
    download: '/cust/expUitemCode.do', // 下载自定义
    mList: '/cust/queryUserItemNew.do', // 自定义编码管理模块列表
    deleteSingle: '/cust/deleteUserItemMag.do', //自定义编码（管理）单条删除
    updateCode: '/cust/updateUserCode.do', // 修改自定义编码
    delete: '/cust/deleteUserItems.do', //批量删除自定义编码
    upload: '/cust/uploadCustomCode.do', //上传文件
    template: '/api/sys/file/template.do', //下载上传的文件
    map: '/cust/queryByUitemCode.do', //上传文件后切换仓库时查询
  },
  // 活动专区
  activeArea: {
    area: {
      detail: '/cust/activityAreas.do', //活动专区图片等
    },
    luckyDraw: {
      // 抽奖
      remainCount: '/api/biz/sp/unUseNum.do', // get 剩余抽奖次数
      addrDefault: '/cust/drawDefaultAddr.do', // get 获取已经设置的地址
      addrList: '/cust/queryDefaultAddr.do', // get 获取收货地址
      addrUpdate: '/cust/updtDrawDefaultAddr.do', // put 更新收货地址
      jackPots: '/api/biz/sp/pcJackPot.do?showArea=1', // get 获取奖池
      luckyList: '/api/foolish/bird/fly/first', // get 获取中奖名单
      myLuckyList: '/api/biz/sp/pcPersonalWin.do', // get 获取我的中奖名单
      rules: '/api/foolish/bird/fly/first', // get 获取抽奖规则
      prize: 'api/biz/sp/drawLottery.do', // get 获取中奖信息
    },
    coupons: {
      // 优惠券
      list: '/cust/activityCoupons.do', //优惠券
      accept: '/cust/activityGetCoupon.do', //领取优惠券
    },
    // 组合销售
    combo: {
      query: '/api/biz/sp/querySalesSetInValid.do', // get 组合销售查询接口
      detail: '/api/biz/sp/querySalesSetInDetail.do', // get 组合销售详情接口
      project: '/api/biz/sp/queryProductsByID.do', // get 规格下拉
      address: '/cust/queryUserAddress.do', //获取配送方式
      save: '/api/biz/sp/saveOrderInSalesSet.do', //提交订单
    },
  },
  finance: {
    check: '/cust/judgeApplyFiance.do', // 判断是否开通
    introduction: '/api/sys/sm/confs.do', // 底部业务介绍
    introductionList: '/sys/queryConfigs.do', // 传list获取系统参数
    snintroduction: 'api/sys/sm/confs.do', // 随宁帖底部业务介绍
    carousel: '/api/biz/cms/postersB2B.do', //东明金融顶部轮播
    apply: '/api/biz/cm/finance.do', //申请开通我的周转通
    limit: '/cust/lineOfCreditAndLoan.do', //额度
    detailList: '/cust/loanDetail.do', //贷款明细
    paymentList: '/cust/queryByMef.do', //应付货款明细
    easyLoanLimit: '/czb/queryLoanAmt.do', // 分销通额度
  },
  profile: {
    info: '/cust/memberInfoAll.do',
    basicInfo: '/cust/memberInfo.do', //基本信息
    application: '/cust/itemApplication.do', //非标申请
    address: '/cust/memberAddressInfo.do',
    default: '/cust/updateMrdz.do', //设为默认
    unCheckDelete: '/cust/deleteDeliveryAddress.do', //删除未审核地址
    checkDelete: '/cust/deleteDeliveryAddress2.do', //删除已审核地址
    edit: '/cust/updateNewAddr.do', // 编辑收货地址
    add: '/cust/saveNewAddr.do', //新增收货地址
    contract: '/cust/custContract.do', //获取签约完成情况
    coupon: '/cust/memberCoupon.do', //优惠券
    redPocket: '/cust/memberRedPacket.do', //红包
    deleteApplication: '/cust/delItemApplication.do', //非标申请删除
    remindList: '/cust/memberArrivalRem.do', //有货提醒列表
    preparatifsList: '/cust/memberArrivalSug.do', //备货建议列表
    deleteRemind: 'cust/delArrivalRemind.do', // 删除有货提醒
    memberPointsInfo: '/points/member/personalMemberInfo.do',
    memberRecord: '/points/record/memberRecord.do', // 会员积分明细
    updateAvatar: '/api/sys/file/head_pic_upload.do',
    queryCouponsAndItems: '/points/item/searchChangeItems.do', // 兑换优惠券或者商品
    placePointsOrder: '/points/order/placePointsOrder.do', // 确认兑换
    queryPointsSetting: '/points/setting/queryPointsSetting.do', // 获取会员明细系统参数
    popupAndGrant: '/points/member/popupAndGrant.do', //监听会员是否每日升级
    applyEquity: '/equity/apply/save.do', // 申请权益
    memberisBlack: '/points/member/black.do', // 当前用户是否屎黑名单
    queryDiscount: '/cust/queryDiscountTable.do', // 折扣表
    discountMenuShow: '/api/biz/cms/articleDisplayOrNot.do', // 判断折扣表菜单是否显示
    downLoadRecord: '/api/biz/cms/downloadRecord.do',
  },
  download: {
    tabs: '/cust/dataDownloadMenu.do', //获取资料下载顶部tab
    detail: '/cust/queryDataDownload{type}.do', //列表信息查询
    download: '/cust/downloadAttach.do', //下载附件
    certificateQuality: '/cust/queryCreatifiContent', //查询品质证明
    certificateQuality1: '/lotn/queryCreatifiContents.do', //查询品质证明
    certificateQuality2: '/lotn/queryMaterialCertification.do', //查询材质证明
    orderCenterDownLoad: '/lotn/downloadLotns.do',
  },
  application: {
    save: '/cust/saveItemApplications.do', //非标申请保存
    material: '/cust/queryProdMaterial.do', //获取材质下拉列表
  },
  BI: {
    group: '/cust/bi/groups.do', //bi分组
    chartList: '/cust/bi/charts.do', //图表列表
    chartOption: '/cust/bi/chart_data.do', //图表选项
  },
  report: {
    chartList: '/cust/report/charts.do', // 图表列表
  },
  stock: {
    stockList: '/cust/querySplitStock.do',
    stockListBySelect: 'cust/stocks.do',
    editStock: '/cust/saveSplitStock.do',
    deleteStock: '/cust/deleteSplitStock.do',
  },
  orderReturn: {
    list: '/cust/orderReturnedQuery.do', //退货单列表
    submit: '/cust/placeReturnedOrder.do', //退货提交
    record: '/cust/roList.do', //退货单记录
    records: 'cust/queryRoMasList.do', // 退货单记录替换
    detail: '/cust/roInfoQuery.do', //退货单详情
    logSubmit: '/cust/roLogisticsSave.do', //物流信息提交
    charge: '/cust/updateRoCause.do', //计算管理费,
    cancel: '/cust/cancelRoMas.do', //取消退货
    upload: '/api/sys/file/upload_pic.do', //图片上传
    check: 'cust/checkReturnedOrder.do', //校验可退货时间
    getSaleNos: '/api/biz/cm/queryFbNoByDoco.do', // 查询客诉单号
    queryCoupons: '/cust/returnCouponSelect.do', // 查询优惠券
    exportRoPdf: 'cust/exportRoPdf.do', //导出退货清单PDF
  },
  // 售后
  applyAfterSales: {
    queryComplainTypes: '/api/biz/cms/detail.do', // 获取问题小类
    queryComplainDesc: '/api/biz/cms/getComplainDesc.do', // 获取问题描述
    submit: '/cust/batchSaveFeedback.do', // 售后提交
  },
  quotation: {
    queryPageBy: '/cust/quotation/queryPageBy.do', //报价单列表
    addProcess: '/cust/quotation/addProcess.do', //查询增值服务
    saveBatchCart: '/cust/quotation/saveBatchCart.do', //搜索页-批量添加购物车
    previewSearch: '/cust/quotation/previewSearch.do', //搜索页预览
    previewCart: '/cust/quotation/previewCart.do', //购物车页-预览
    save: '/cust/quotation/save.do', //保存报价明细
    download: '/cust/quotation/download.do', //下载报价单
    addCart: '/cust/quotation/addCart.do', //报价单一键加入购物车
    delete: '/cust/quotation/delete.do', // 删除报价单
    batchDelete: '/cust/quotation/deleteBatch.do', // 批量删除报价单
  },
  biLog: {
    addLog: '/cust/track/add_log.do', //埋点日志上报
  },
  webIm: {
    getUnReadCount: 'im/msg/count.do',
    fetchImInfo: '/im/user/currentImInfo.do',
    getGroups: '/im/groups.do',
    getCustomer: '/im/agents.do',
    queryMsgList: '/im/msg/queryList.do',
    sendMsg: '/im/msg/sendMsg.do',
    recallMsg: '/im/msg/recall.do',
    read: '/im/msg/read.do',
    readSession: '/im/msg/readSession.do',
    createGroup: '/im/createGroup.do',
    deleteGroup: '/im/deleteGroup.do',
  },
  defaultMcu: {
    queryList: '/cust/queryDefaultMcu.do',
    saveMcu: '/cust/saveDefaultMcu.do',
    batchDeleteMcu: '/cust/deleteDefaultMcu.do',
  },
  customDemand: {
    submit: '/api/biz/demand/save.do', //非标申请保存
    list: '/api/biz/demand/demandList.do', //非标申请列表
    detail: '/api/biz/demand/demandInfo.do', //非标申请详情
    download: '/api/sys/file/demand_attachment_download.do', //下载附件
  },
};
